<app-header></app-header>
<router-outlet (onActivate)="scroll()"></router-outlet>
<app-footer></app-footer>